<div class="container">
  <div class="instructions">
    <p class="text">
      {{ 'upgrade.pfa.wizard.section-1.instructions.billing' | transloco }}
    </p>
    <p class="text">
      {{ 'upgrade.pfa.wizard.section-1.instructions.orgData' | transloco }}
    </p>
  </div>
  <div class="divider">
    <div class="line"></div>
  </div>
  <div class="form">
    <markant-platform-additional-org-data-form
      [showErrors]="showErrors()"
      [form]="form()"
      [mode]="'edit'"
    />
  </div>
</div>
